import React, { useState } from "react";
import img1 from "../imgs/Galleria/orchestra01_sito.jpg";
import img2 from "../imgs/Galleria/orchestra05_sito.jpg";
import img3 from "../imgs/Galleria/orchestra04_sito.jpg";
import img4 from "../imgs/Galleria/ottoni_sito.jpg";
import img5 from "../imgs/Galleria/sezione01_sito.jpg";
import img6 from "../imgs/Galleria/sezione02_sito.jpg";
import img7 from "../imgs/Galleria/foto01.jpg";
import img8 from "../imgs/Galleria/NOM_04_risultato.jpg";
import img9 from "../imgs/Galleria/NOM_05_risultato.jpg";
import img10 from "../imgs/Galleria/NOM_06_risultato.jpg";
import img11 from "../imgs/Galleria/NOM_08_risultato.jpg";
import img12 from "../imgs/Galleria/NOM_11_risultato.jpg";
import img13 from "../imgs/Galleria/NOM_13_risultato.jpg";
import img14 from "../imgs/Galleria/NOM_16_risultato.jpg";
import img15 from "../imgs/Galleria/NOM_20_risultato.jpg";
import img16 from "../imgs/Galleria/NOM_21_risultato.jpg";
import img17 from "../imgs/Galleria/NOM_24_risultato.jpg";
import img18 from "../imgs/Galleria/NOM_25_risultato.jpg";
import img19 from "../imgs/Galleria/NOM_26_risultato.jpg";
import img20 from "../imgs/Galleria/NOM_29_risultato.jpg";
import img21 from "../imgs/Galleria/NewGallery (1).jpg";
import img22 from "../imgs/Galleria/NewGallery (2).jpg";
import img23 from "../imgs/Galleria/NewGallery (3).jpg";
import img24 from "../imgs/Galleria/NewGallery (4).jpg";
import img25 from "../imgs/Galleria/NewGallery (5).jpg";
import img26 from "../imgs/Galleria/NewGallery (6).jpg";
import img27 from "../imgs/Galleria/NewGallery (7).jpg";
import img28 from "../imgs/Galleria/NewGallery (8).jpg";
import img29 from "../imgs/Galleria/NewGallery (9).jpg";
import img30 from "../imgs/Galleria/NewGallery (10).jpg";
import img31 from "../imgs/Galleria/NewGallery (11).jpg";
import img32 from "../imgs/Galleria/NewGallery (12).jpg";
import img33 from "../imgs/Galleria/NewGallery (13).jpg";

const Galleria = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (img) => {
    setSelectedImage(img);
  };

  const handleClose = () => {
    setSelectedImage(null);
  };

  return (
    <div className="flex flex-col items-center z-10">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        GALLERIA
      </p>
      <div className="grid xs:grid-cols-2 md:grid-cols-4 gap-2 justify-center items-center">
        <img
          src={img1}
          onClick={() => handleImageClick(img1)}
          className="cursor-pointer"
        />
        <img
          src={img2}
          onClick={() => handleImageClick(img2)}
          className="cursor-pointer"
        />
        <img
          src={img3}
          onClick={() => handleImageClick(img3)}
          className="cursor-pointer"
        />
        <img
          src={img4}
          onClick={() => handleImageClick(img4)}
          className="cursor-pointer"
        />
        <img
          src={img5}
          onClick={() => handleImageClick(img5)}
          className="cursor-pointer"
        />
        <img
          src={img6}
          onClick={() => handleImageClick(img6)}
          className="cursor-pointer"
        />
        <img
          src={img7}
          onClick={() => handleImageClick(img7)}
          className="cursor-pointer"
        />
        <img
          src={img8}
          onClick={() => handleImageClick(img8)}
          className="cursor-pointer"
        />
        <img
          src={img9}
          onClick={() => handleImageClick(img9)}
          className="cursor-pointer"
        />
        <img
          src={img10}
          onClick={() => handleImageClick(img10)}
          className="cursor-pointer"
        />
        <img
          src={img11}
          onClick={() => handleImageClick(img11)}
          className="cursor-pointer"
        />
        <img
          src={img12}
          onClick={() => handleImageClick(img12)}
          className="cursor-pointer"
        />
        <img
          src={img13}
          onClick={() => handleImageClick(img13)}
          className="cursor-pointer"
        />
        <img
          src={img14}
          onClick={() => handleImageClick(img14)}
          className="cursor-pointer"
        />
        <img
          src={img15}
          onClick={() => handleImageClick(img15)}
          className="cursor-pointer"
        />
        <img
          src={img16}
          onClick={() => handleImageClick(img16)}
          className="cursor-pointer"
        />
        <img
          src={img17}
          onClick={() => handleImageClick(img17)}
          className="cursor-pointer"
        />
        <img
          src={img18}
          onClick={() => handleImageClick(img18)}
          className="cursor-pointer"
        />
        <img
          src={img19}
          onClick={() => handleImageClick(img19)}
          className="cursor-pointer"
        />
        <img
          src={img20}
          onClick={() => handleImageClick(img20)}
          className="cursor-pointer"
        />
        <img
          src={img21}
          onClick={() => handleImageClick(img21)}
          className="cursor-pointer"
        />
        <img
          src={img22}
          onClick={() => handleImageClick(img22)}
          className="cursor-pointer"
        />
        <img
          src={img23}
          onClick={() => handleImageClick(img23)}
          className="cursor-pointer"
        />
        <img
          src={img24}
          onClick={() => handleImageClick(img24)}
          className="cursor-pointer"
        />
        <img
          src={img25}
          onClick={() => handleImageClick(img25)}
          className="cursor-pointer"
        />
        <img
          src={img26}
          onClick={() => handleImageClick(img26)}
          className="cursor-pointer"
        />
        <img
          src={img27}
          onClick={() => handleImageClick(img27)}
          className="cursor-pointer"
        />
        <img
          src={img28}
          onClick={() => handleImageClick(img28)}
          className="cursor-pointer"
        />
        <img
          src={img29}
          onClick={() => handleImageClick(img29)}
          className="cursor-pointer"
        />
        <img
          src={img30}
          onClick={() => handleImageClick(img30)}
          className="cursor-pointer"
        />
        <img
          src={img31}
          onClick={() => handleImageClick(img31)}
          className="cursor-pointer"
        />
        <img
          src={img32}
          onClick={() => handleImageClick(img32)}
          className="cursor-pointer"
        />
        <img
          src={img33}
          onClick={() => handleImageClick(img33)}
          className="cursor-pointer"
        />
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50 h-auto"
          onClick={handleClose}
        >
          <div className="relative">
            <button
              className="absolute top-0 right-0 m-4 text-white text-3xl font-bold"
              onClick={handleClose}
            >
              &times;
            </button>
            <img src={selectedImage} className="w-auto xs:h-80 md:h-svh" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Galleria;
